import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface ConfirmMemberModel {
	title:string;
    message:string;
	message_second:string;
	button:string;
}

@Component({  
    selector: 'confirm-member',
    template: `<div class="modal-dialog">
	                <div class="modal-content">
	                   	<div class="modal-header">
	                     	<h4 class="modal-title">{{title}}</h4>
	                     	<button type="button" class="close" (click)="close()" >&times;</button>
	                   	</div>
	                   	<div class="modal-body">
	                     	<p>{{message}}</p>
                            <p>{{message_second}}</p>
	                   	</div>
	                   	<div class="modal-footer">
	                     	<button type="button" class="btn btn-primary" (click)="confirm()">{{button}}</button>
	                     	<button type="button" class="btn btn-danger" (click)="close()">Natrag</button>
	                   	</div>
	                </div>
              	</div>`,
    styles: [
    	`
        .modal-dialog{
            width: 40%;
            max-width: 40%;
        }
    	.modal-footer,
    	.modal-body { 
    		border-top: 1px solid #eceeef;
            color: #ec1c24; 
    	}
    	.modal-header {
    		padding: 10px 15px;
    	}
    	`]
})

export class ConfirmMemberComponent extends DialogComponent<ConfirmMemberModel, boolean> implements ConfirmMemberModel {
  	title: string;
    message: string;
  	message_second: string;
  	button: string;
  	constructor(dialogService: DialogService) {
    	super(dialogService);
  	}
  	confirm() {
    	// we set dialog result as true on click on confirm button, 
    	// then we can get dialog result from caller code 
    	this.result = true;
    	this.close();
  	}
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/confirm/confirm-member.component.ts